import { RegisterWrapper, RegisterDisplayer, AnimatedBackground } from "./Styles";
import { useRecoilState } from "recoil";
import MikeLogo from "../../Assets/logo.png";
import { SignUpForm } from "./Components/SignUpForm";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { registerState } from "../../Common/State/Register";
import styled from "styled-components";

const RegisterWrapperWithBackground = styled(RegisterWrapper)`
  background-color: #001d30;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 100vh;
  height: auto;
  padding-top: 2rem;
  padding-bottom: 2rem;

  > img {
    z-index: 10;
    position: relative;
    width: auto;
    height: 3rem;
    margin-bottom: 1rem;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;

    > img {
      height: 2.5rem;
      margin-bottom: 0.75rem;
    }
  }
`;

const RegisterDisplayerStyled = styled(RegisterDisplayer)`
  background-color: #fff !important;
  z-index: 10;
  position: relative;
  max-width: 520px;
  width: 100%;
  padding: 2.5rem;
  border-radius: 1rem;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  border: 1px solid #F2F3F7;
  margin-bottom: 1rem;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    width: 90%;
    padding: 1.5rem;
    margin-bottom: 0.5rem;
    max-width: calc(100% - 1rem);
    margin-left: auto;
    margin-right: auto;
  }
`;

export const Register = () => {
  const { t } = useTranslation();
  const [, setRegisterStep] = useRecoilState(registerState);

  useEffect(() => {
    setRegisterStep((prev) => ({
      ...prev,
      step: 1,
    }));
  }, []);

  return (
    <RegisterWrapperWithBackground>
      <AnimatedBackground>
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
      </AnimatedBackground>
      <img src={MikeLogo} alt={t("auth.register.mikeLogoAlt")} />
      <RegisterDisplayerStyled>
        <SignUpForm />
      </RegisterDisplayerStyled>
    </RegisterWrapperWithBackground>
  );
};
